<div class="modal-content">
  <div class="modal__content">
    <div class="modal__header">
      <h3 class="h3 modal__title">
        {{ data.title }}
      </h3>
      <button (click)="onClickClose()" type="button" class="modal__close">
        <img src="assets/images/icons/close.svg" />
      </button>
    </div>

    <div class="modal__body info-section__body">
      <swiper
        *ngIf="imageGalleryIsVisible"
        class="info-section__swiper"
        [config]="swiperConfig"
        [initialSlide]="initialSlide"
      >
        <ng-template *ngFor="let imageItem of data.imageGallery" swiperSlide>
          <img
            class="info-section__limit-max"
            [src]="getImgUrl(imageItem.url)"
          />
        </ng-template>
      </swiper>

      <div *ngFor="let infoSection of data.infoSections">
        <ng-container *ngIf="isDefault(infoSection)">
          <h4 class="h4 info-section__default__title">
            {{ infoSection.name }}
          </h4>
          <p [innerHTML]="infoSection.body" class="info-section__default"></p>
        </ng-container>

        <ng-container *ngIf="isParts(infoSection)">
          <div *ngIf="data.estimateParts?.checkpoints as checkPoints">
            <div
              *ngFor="let checkpoint of checkPoints"
              class="info-section__operations"
            >
              <div>{{ checkpoint.units }} {{ checkpoint.desc }}</div>
              <span
                *ngIf="checkpoint.base_standard !== null"
                class="info-section__operations__price"
              >
                {{ checkpoint.base_standard | number: '1.2-2' }}€
              </span>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="isOperations(infoSection)">
          <div *ngIf="data.estimateOperations?.checkpoints as checkPoints">
            <div
              *ngFor="let checkpoint of checkPoints"
              class="info-section__operations"
            >
              <div>
                {{ checkpoint.title }}
              </div>

              <span
                *ngIf="checkpoint.base_standard !== null"
                class="info-section__operations__price"
              >
                {{ checkpoint.base_standard | number: '1.2-2' }}€
              </span>
            </div>

            <p
              *ngIf="subDetailIsVisible"
              (click)="onExpandCollapseSubOperations()"
              class="info-section__operations"
            >
              <span
                class="info-section__operations__title"
                [class.expanded]="subDetailsCollapse"
              >
                {{
                  'sharedModule.bkgInfoSectionDialog.checkControls'
                    | translate
                      : {
                          controlsLength:
                            data.estimateOperations.subdetail_control.length
                        }
                }}
              </span>
            </p>

            <div
              *ngIf="subDetailsCollapse"
              class="info-section__operations__subdetail"
            >
              <ul *ngIf="subDetailIsVisible">
                <li
                  *ngFor="
                    let subdetail of data.estimateOperations.subdetail_control
                  "
                >
                  {{ subdetail.title }}
                </li>
              </ul>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="isTags(infoSection)">
          <p [innerHTML]="infoSection.body" class="info-section__tags"></p>
        </ng-container>

        <ng-container *ngIf="isPriceDetail(infoSection)">
          <div class="info-section__price-detail">
            <span>{{
              'sharedModule.bkgInfoSectionDialog.price' | translate
            }}</span>
            <span>{{ data.carServicePrice.base | number: '1.2-2' }}€</span>
          </div>
          <div class="info-section__price-detail">
            <span>{{
              'sharedModule.bkgInfoSectionDialog.vat' | translate
            }}</span>
            <span>{{ data.carServicePrice.vat | number: '1.2-2' }}€</span>
          </div>
          <div class="info-section__price-detail">
            <span>{{
              'sharedModule.bkgInfoSectionDialog.totalPrice' | translate
            }}</span>
            <span
              >{{ data.carServicePrice.price | number: '1.2-2' }}€
              <span
                class="info-section__taxes-point"
                *ngIf="data.carServicePrice.taxes"
              >
                {{ 'servicesStep.bkgCarServices.needFees' | translate }}(*)
              </span>
            </span>
          </div>
          <div *ngIf="data.carServicePrice.taxes" style="padding: 15px">
            <span>{{ data.carServicePrice.taxes }}</span>
          </div>
        </ng-container>

        <ng-container *ngIf="isPrice(infoSection)">
          <h5 class="h3">{{ infoSection.name | number: '1.2-2' }}€</h5>
          <p [innerHTML]="infoSection.body"></p>
        </ng-container>
      </div>
      <div class="info-section__div_bottom">
        <button
          (click)="isProcessing ? null : onClickSelect()"
          type="button"
          class="btn-large is-block info-section__button_bottom info-section__limit-max"
          [class.btn-primary]="!isRemove"
          [class.btn-danger]="isRemove"
          [class.disabled]="isProcessing"
        >
          {{ data.confirmTextTranslationKey | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
